import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, message, Space, Spin, Typography } from 'antd';
import { ArrowLeftOutlined, TeamOutlined } from '@ant-design/icons';
import { classAPI } from '../../services/api';
import ClassCadreManagement from './ClassCadreManagement';

const { Title, Text } = Typography;

const ClassCadreManagePage = () => {
  const { classId } = useParams();
  const navigate = useNavigate();
  const [classInfo, setClassInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (classId) {
      fetchClassInfo();
    }
  }, [classId]);

  const fetchClassInfo = async () => {
    try {
      setLoading(true);
      const response = await classAPI.getById(classId);
      if (response.data.success) {
        setClassInfo(response.data.data);
        return;
      }

      message.error('获取班级信息失败');
      navigate('/classes/cadres');
    } catch (error) {
      console.error('获取班级信息失败:', error);
      message.error('获取班级信息失败');
      navigate('/classes/cadres');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!classInfo) {
    return (
      <Card>
        <p>班级信息不存在</p>
        <Button onClick={() => navigate('/classes/cadres')}>返回选择班级</Button>
      </Card>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Space>
            <Button type="text" icon={<ArrowLeftOutlined />} onClick={() => navigate('/classes/cadres')}>
              返回
            </Button>
            <TeamOutlined style={{ fontSize: 24, color: '#1890ff' }} />
            <div>
              <Title level={4} style={{ margin: 0 }}>
                {classInfo.name} - 班干部管理
              </Title>
              <Text type="secondary">
                {classInfo.school_name} {classInfo.grade && `· ${classInfo.grade}`}
              </Text>
            </div>
          </Space>
        </div>

        <ClassCadreManagement classId={classId} />
      </Card>
    </div>
  );
};

export default ClassCadreManagePage;
